/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SiteEmailSettingParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SITE_EMAIL')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class SiteEmailSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SiteEmailSettingParser.decode(input).map(res => new SiteEmailSetting(res));
    }
    static unsafeDecode(input) {
        return SiteEmailSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SiteEmailSettingParser.encode(data);
    }
    static schema() {
        return SiteEmailSettingParser.schema();
    }
}
